import React from 'react';

class FAQ extends React.Component {
    state = { expanded: false }
    componentWillReceiveProps = nextProps => {
        const { qa } = this.props;
        if (nextProps.qa && nextProps.qa.id !== qa.id) {
            this.setState({ expanded: false });
        }
    }
    toggleExpand = () => this.setState({ expanded: !this.state.expanded });
    render() {
        const { expanded } = this.state, { qa } = this.props;
        return <div onClick={this.toggleExpand} key={qa.id}>
            <div className="d-flex flex-row p-2" >
                <span className="hind font-14 black align-self-center toBold">{qa.Question}</span>
                <i className={`ml-auto black align-self-center fas fa-${expanded ? 'minus' : 'plus'} font-20`} />
            </div>
            {expanded && <p className="gray margin-top font-12 hind" dangerouslySetInnerHTML={{ __html: qa.Answer }} ></p>}
            <hr />
        </div>
    }
}

export default FAQ;


// WEBPACK FOOTER //
// ./src/components/faqs/partials/faq.js